module.exports = __webpack_public_path__ + "static/media/24-1.e9257068.mp3";